module.exports = __webpack_public_path__ + "static/media/quote3.ad325edb.png";